<template>
  <div class="area_sitemap" :class="{ open, on: open }">
    <button ref="openBtnRef" type="button" class="btn_sitemap_open" @click.prevent="update(true)">사이트맵</button>

    <div class="box_sitemap" :class="{ open }" :inert="!open" :aria-hidden="open ? 'false' : 'true'">
      <button ref="closeBtnRef" class="btn_sitemap_close" @click="update(false)">전체메뉴 닫기</button>
      <div class="inr">
        <h2 class="sitemap_tit">전체메뉴</h2>

        <ul class="lst_sitemap">
          <!-- 1 depth -->
          <li v-for="(section, i) in sitemapNav" :key="i">
            <a
                :href="section.href"
                :target="section.target || undefined"
                :rel="relFor(section)"
                :title="section.title || undefined"
                :data-type-menu="section.menuNm"
                @click.prevent="navigate(section)"
            >
              <span>{{ section.menuNm }}</span>
            </a>

            <!-- 2 depth -->
            <div v-if="section.children?.length">
              <ul>
                <li v-for="(child, j) in section.children" :key="j">
                  <a
                      :href="child.href"
                      :target="child.target || undefined"
                      :rel="relFor(child)"
                      :title="child.title || undefined"
                      @click.prevent="navigate(child)"
                  >
                    <span>{{ child.menuNm }}</span>
                  </a>

                  <!-- 3 depth -->
                  <ul v-if="child.children?.length">
                    <li v-for="(grand, k) in child.children" :key="k">
                      <a
                          :href="grand.href"
                          :target="grand.target || undefined"
                          :rel="relFor(grand)"
                          :title="grand.title || undefined"
                          @click.prevent="navigate(grand)"
                      >
                        <span>{{ grand.menuNm }}</span>
                      </a>
                    </li>
                  </ul>
                </li>
              </ul>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script setup>
import {onBeforeUnmount, onMounted, ref, computed, nextTick } from 'vue'
import { useRouter } from 'vue-router'
import {useApiMenu} from '@/composables/useApiMenu'

defineOptions({
  name: 'Sitemap',
  inheritAttrs: false,
})

const router = useRouter()

const open = ref(false)
const openBtnRef = ref(null)
const closeBtnRef = ref(null)

const update = async (v) => {
  open.value = v
  // 열릴 때 body 스크롤 막기 — 닫힐 때 복원 (스크롤바 중복 방지)
  document.body.classList.toggle('fixed_sitemap', v)

  await nextTick()

  if (v) {
    closeBtnRef.value?.focus?.()
  } else {
    openBtnRef.value?.focus?.()
  }
}

const DOMAIN_ID = import.meta.env.VITE_DOMAIN_ID
const {getMenuTree} = useApiMenu()

// 외부 URL 여부 판단
const isExternalUrl = (url) =>
  !!url && (url.startsWith('http://') || url.startsWith('https://') || url.startsWith('//'))

const sitemapNav = computed(() => {
  const tree = getMenuTree(DOMAIN_ID)

  const filterByIndct = (menus) => {
    return menus
      .filter(menu => menu.menuIndctYn === 'Y')
      .map(menu => {
        const href = menu.path || menu.menuLink || '#'
        // 외부 URL이면 새창 처리
        const target = menu.target || (isExternalUrl(href) ? '_blank' : undefined)
        return {
          ...menu,
          href,
          target,
          children: menu.children ? filterByIndct(menu.children) : []
        }
      })
  }

  return filterByIndct(tree)
})

// 하위에서 첫 번째 유효 href 탐색 (1차 메뉴가 DIR일 때 사용)
const findFirstChildHref = (children) => {
  if (!children?.length) return null
  for (const child of children) {
    if (child.href && child.href !== '#') return child.href
    const nested = findFirstChildHref(child.children)
    if (nested) return nested
  }
  return null
}

// 링크 클릭 처리: 사이트맵 닫기 + 내부/외부 분기
const navigate = (menu) => {
  let href = menu.href

  // 직접 링크 없는 1차 메뉴(DIR): 첫 번째 유효 자식 링크로 이동
  if (!href || href === '#') {
    href = findFirstChildHref(menu.children)
  }

  if (!href || href === '#') return

  update(false)

  if (menu.target === '_blank' || isExternalUrl(href)) {
    window.open(href, '_blank', 'noopener,noreferrer')
  } else {
    router.push(href)
  }
}

const onKeydown = (e) => {
  if (!open.value) return
  if (e.key === 'Escape') {
    e.preventDefault()
    update(false)
  }
}

onMounted(() => window.addEventListener('keydown', onKeydown))
onBeforeUnmount(() => {
  window.removeEventListener('keydown', onKeydown)
  document.body.classList.remove('fixed_sitemap') // 컴포넌트 해제 시 잔류 클래스 제거
})

const relFor = (item) => item?.rel || (item?.target === '_blank' ? 'noopener noreferrer' : undefined)

document.addEventListener("keydown", function (e) {
  const sitemap = document.querySelector(".box_sitemap");
  if (!sitemap || !sitemap.classList.contains("open")) return;

  if (e.key === "Tab") {
    const focusableEls = sitemap.querySelectorAll(
      'a[href], button, textarea, input[type="text"], input[type="radio"], input[type="checkbox"], select',
    );
    const firstEl = focusableEls[0];
    const lastEl = focusableEls[focusableEls.length - 1];

    if (e.shiftKey) {
      /* Shift + Tab */
      if (document.activeElement === firstEl) {
        lastEl.focus();
        e.preventDefault();
      }
    } else {
      if (document.activeElement === lastEl) {
        firstEl.focus(); 
        e.preventDefault();
      }
    }
  }
});
</script>
